var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFla = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m489.715 167.004v284.952c0 26.534-21.51 48.044-48.044 48.044h-296.28c-26.534 0-48.044-21.51-48.044-48.044v-391.912c0-26.534 21.51-48.044 48.044-48.044h198.441z",
    fill: "#724b46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.714 167.004h-113.853c-17.689 0-32.029-14.34-32.029-32.029v-122.974z",
    fill: "#452620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.888 427.607h-371.403c-5.081 0-9.2-4.119-9.2-9.2v-168.324c0-5.081 4.119-9.2 9.2-9.2h371.403c5.081 0 9.2 4.119 9.2 9.2v168.324c0 5.081-4.119 9.2-9.2 9.2z",
    fill: "#452620"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m126.813 382.919c-1.814 0-3.441-.375-4.911-1.126s-2.221-1.939-2.221-3.566v-88.925c0-1.533.657-2.69 2.002-3.472 1.345-.813 2.784-1.251 4.316-1.251h47.231c1.595 0 2.753.688 3.472 2.033s1.095 2.721 1.095 4.16c0 1.72-.375 3.222-1.157 4.504-.751 1.314-1.908 1.971-3.409 1.971h-39.286v30.809h20.832c1.533 0 2.69.563 3.441 1.752.751 1.157 1.157 2.502 1.157 4.004 0 1.282-.375 2.502-1.095 3.722-.719 1.22-1.877 1.814-3.503 1.814h-20.832v38.879c0 1.626-.751 2.815-2.221 3.566-1.501.751-3.128 1.126-4.911 1.126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.812 382.919c-1.533 0-2.971-.375-4.316-1.189-1.345-.813-2.002-1.971-2.002-3.503v-89.05c0-1.626.751-2.784 2.221-3.503s3.097-1.095 4.911-1.095c1.783 0 3.409.375 4.911 1.095 1.47.719 2.221 1.877 2.221 3.503v81.105h34.969c1.439 0 2.502.657 3.222 1.939.719 1.314 1.095 2.784 1.095 4.379 0 1.533-.375 2.971-1.095 4.316s-1.783 2.002-3.222 2.002h-42.915z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.116 382.919c-1.251 0-2.596-.25-4.035-.813-1.439-.5-2.596-1.189-3.503-2.064-.907-.845-1.345-1.877-1.345-3.003 0-.313.031-.688.125-1.251l26.774-87.142c.532-1.626 1.689-2.815 3.441-3.628s3.597-1.22 5.568-1.22c2.064 0 3.972.407 5.724 1.22s2.878 2.002 3.441 3.628l26.618 87.142c.188.563.282.938.282 1.251 0 1.063-.469 2.064-1.408 2.94s-2.127 1.626-3.503 2.127c-1.408.563-2.753.813-4.098.813-1.189 0-2.19-.188-3.034-.657s-1.47-1.22-1.814-2.283l-5.505-19.111h-33.374l-5.38 19.111c-.282 1.063-.876 1.814-1.814 2.283s-2.002.657-3.16.657zm13.575-33.468h26.9l-13.45-46.167z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFla);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fla.447f047a7bb144751aa490516d4a7edf.svg";